import * as React from 'react';
import Slider from 'react-slick';

import { SEO } from 'main/components';

import discorverFeel from '../../../main/assets/images/fpvctrl/discover-feel.webp';
import discoverButtons from '../../../main/assets/images/fpvctrl/discover-buttons.webp';
import discoverCharging from '../../../main/assets/images/fpvctrl/discover-charging.webp';
import fpvctrlSide from '../../../main/assets/images/fpvctrl/fpvctrl-side.webp';
import logoOrqaSymbol from '../../../main/assets/images/orqa-logo.png';
import iconMap from '../../../main/assets/icons/icon-map.svg';
import iconPc from '../../../main/assets/icons/icon-pc.svg';
import iconDrone from '../../../main/assets/icons/icon-drone.svg';
import iconGear from '../../../main/assets/icons/icon-gear.svg';
import skydiveDrone from '../../../main/assets/images/fpvctrl/skydive-drone.webp';
import fpvctrlPhone from '../../../main/assets/images/fpvctrl/phone.webp';
import fpvctrlModels from '../../../main/assets/images/fpvctrl/fpvctrl-models.webp';
import fpvctrlMenu from '../../../main/assets/images/fpvctrl/fpvctrl-menu.webp';
import fpvctrlInfo from '../../../main/assets/images/fpvctrl/fpvctrl-info.webp';
import fpvconnectGoogleplay from '../../../main/assets/pages/fpvconnect/fpvconnect-googleplay.webp';
import fpvConnectAppstore from '../../../main/assets/pages/fpvconnect/fpvconnect-appstore.webp';
import fpvCtrlProduct from '../../../main/assets/images/fpvctrl/fpv-ctrl-product.webp';
import fpvGhostController from '../../../main/assets/images/fpvctrl/fpv-ctrl-ghost-controller.webp';

interface State {
  loading: boolean;
  isMobile: boolean;
  isVertTablet: boolean;
  extraSmallMobile: boolean;
}

export class FPVCtrl extends React.Component<{}, State> {
  state: State = {
    loading: true,
    isMobile: false,
    isVertTablet: false,
    extraSmallMobile: false,
  };

  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    const isMobile = window.innerWidth <= 767;
    const isVertTablet = window.innerWidth <= 991;
    const extraSmallMobile = window.innerWidth <= 350;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }

    if (isVertTablet !== this.state.isVertTablet) {
      this.setState({ isVertTablet });
    }

    if (extraSmallMobile !== this.state.extraSmallMobile) {
      this.setState({ extraSmallMobile });
    }
  };

  render() {
    const { isMobile } = this.state;

    const settings = {
      arrows: !isMobile,
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    const settingsMobile = {
      arrows: false,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
    };

    return (
      <>
        <SEO seoTitle="FPV Controller - Best Remote Drone Radio Transmitter - Orqa" />
        <section className="fpvctrl">
          <section className="fpvctrl-hero-parent">
            <div className="fpvctrl-hero">
              <div className="fpvctrl-hero-text">
                <div className="fpvctrl-hero-title-section">
                  <h1 className="fpvctrl-hero-subtitle">FPV.Ctrl</h1>
                  <h2 className="fpvctrl-hero-title">FLAWLESS CONTROL</h2>
                </div>
                <p className="fpvctrl-hero-description">
                  The essential link between pilot and craft. FPV.Ctrl delivers
                  the low-latency response needed to master both simulators and
                  the sky. Engineered for enduring comfort and built to
                  withstand the field, its sturdy frame gives you the confidence
                  to fly mission after mission.
                </p>
                <div className="dreamX__discover--button">
                  <a
                    href="https://shop.orqafpv.com/products/orqa-orqa-fpv-ctrl-radio-controller"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn--primary btn--med"
                    onMouseDown={event => event.preventDefault()}
                  >
                    buy now
                  </a>
                </div>
              </div>
              <img
                src={fpvCtrlProduct}
                alt="FPV Ctrl Product"
                className="fpvctrl-hero-product"
              />
            </div>
          </section>

          {/* <section className="fpvctrl__header--wrapper">
            <div className="fpvctrl__header--content">
              <h1 className="fpvctrl__header--title">FPV.Ctrl</h1>
              <p className="fpvctrl__header--description">
                Wireless radio controller for FPV drones and simulators.
              </p>
              <a
                href="https://shop.orqafpv.com/products/orqa-orqa-fpv-ctrl-radio-controller"
                className="btn btn--primary btn--med"
                target="_blank"
                rel="noopener noreferrer"
                onMouseDown={event => event.preventDefault()}
              >
                Buy now
              </a>
            </div>
            <InView triggerOnce={false}>
              {({ ref, inView }) => {
                return (
                  <div ref={ref} className="fpvctrl__header--secondary">
                    <LazyImage
                      src={fpvctrlNoLeds}
                      alt="FPV.Ctrl Controller for Drones"
                      className="fpvctrl__header--img"
                    />
                    <motion.img
                      initial={{ opacity: 0 }}
                      animate={{ opacity: inView ? 1 : 0 }}
                      transition={{ duration: 0.4, delay: 1.5 }}
                      src={iconLed}
                      alt="Empty Battery Indicator"
                      className="fpvctrl__header--icon fpvctrl__header--icon-1"
                    />
                    <motion.img
                      initial={{ opacity: 0 }}
                      animate={{ opacity: inView ? 1 : 0 }}
                      transition={{ duration: 0.8, delay: 1.5 }}
                      src={iconLed}
                      alt="Low Battery Indicator"
                      className="fpvctrl__header--icon fpvctrl__header--icon-2"
                    />
                    <motion.img
                      initial={{ opacity: 0 }}
                      animate={{ opacity: inView ? 1 : 0 }}
                      transition={{ duration: 1.2, delay: 1.5 }}
                      src={iconLed}
                      alt="High Battery Indicator"
                      className="fpvctrl__header--icon fpvctrl__header--icon-3"
                    />
                    <motion.img
                      initial={{ opacity: 0 }}
                      animate={{ opacity: inView ? 1 : 0 }}
                      transition={{ duration: 1.6, delay: 1.5 }}
                      src={iconLed}
                      alt="Full Battery Indicator"
                      className="fpvctrl__header--icon fpvctrl__header--icon-4"
                    />
                  </div>
                );
              }}
            </InView>
          </section> */}

          <section id="discover-fpvctrl" className="fpvctrl-discover-section">
            <h2 className="fpvctrl-discover-title">Discover FPV.Ctrl</h2>
            <div className="fpvctrl-slider-container">
              <Slider {...settings} className="fpvctrl-slider">
                <div className="fpvctrl-slide">
                  <img
                    src={discorverFeel}
                    alt="Integrated Components"
                    className="fpvctrl-slide-image"
                  />
                </div>

                <div className="fpvctrl-slide">
                  <img
                    src={discoverButtons}
                    alt="Controller's Buttons"
                    className="fpvctrl-slide-image"
                  />
                </div>

                <div className="fpvctrl-slide">
                  <img
                    src={discoverCharging}
                    alt="Controller Charging"
                    className="fpvctrl-slide-image"
                  />
                </div>
              </Slider>
            </div>
          </section>

          <section style={{ position: 'relative', width: '100%' }}>
            {!this.state.isMobile && (
              <img
                src={fpvctrlSide}
                alt="Side View Appearance"
                className="fpvctrl-better-img"
              />
            )}

            <div id="LearnByPlaying" className="fpvctrl-better-section">
              <div className="fpvctrl-better-text">
                <div className="fpvctrl-better-titles">
                  <h3 className="fpvctrl-better-subtitle">
                    Become a better pilot
                  </h3>
                  <h2 className="fpvctrl-better-title">Become a better</h2>
                </div>

                <div className="fpvctrl-better-description-container">
                  <p className="fpvctrl-better-description">
                    Whether you plan to pilot your first drone or simply enjoy
                    freestyling, the experience can be similar to learning to
                    drive a car. Many elements need to tune in together to get a
                    head start. Getting to know the correct technique can be
                    stressful, time-consuming and financially draining.
                  </p>
                  {this.state.isVertTablet ? (
                    <p className="fpvctrl-better-description fpvctrl-better-description-shorten">
                      <span className="short-line short-line--1">
                        What if the winding road to piloting drones was
                        supported
                      </span>
                      <span className="short-line short-line--2">
                        by{' '}
                        <a
                          href="https://store.steampowered.com/app/1278060/FPV_SkyDive__FPV_Drone_Simulator/"
                          target="_blank"
                          rel="noopener noreferrer nofollow"
                          onMouseDown={event => event.preventDefault()}
                        >
                          Orqa FPV.Skydive
                        </a>{' '}
                        racing and freestyle simulator
                      </span>
                      <span className="short-line short-line--3">
                        optimized for an immersive flying experience?
                      </span>
                      <span className="short-line short-line--4">
                        Orqa FPV.Ctrl guides your pilot journey providing
                      </span>
                      <span className="short-line short-line--5">
                        a safe space to sharpen your skills, enhance
                      </span>
                      <span className="short-line short-line--6">
                        safety and build confidence without
                      </span>
                      <span className="short-line short-line--7">
                        the threat of crashes.
                      </span>
                    </p>
                  ) : (
                    <p className="fpvctrl-better-description">
                      What if the winding road to piloting drones was supported
                      by{' '}
                      <a
                        href="https://store.steampowered.com/app/1278060/FPV_SkyDive__FPV_Drone_Simulator/"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        onMouseDown={event => event.preventDefault()}
                      >
                        Orqa FPV.Skydive
                      </a>{' '}
                      racing and freestyle simulator optimized for an immersive
                      flying experience? Orqa FPV.Ctrl guides your pilot journey
                      providing a safe space to sharpen your skills, enhance
                      safety and build confidence without the threat of crashes.
                    </p>
                  )}
                </div>
              </div>

              {this.state.isMobile && (
                <img
                  src={fpvctrlSide}
                  alt="Side View Appearance"
                  className="fpvctrl-better-img"
                />
              )}

              {this.state.isMobile && (
                <p className="fpvctrl-better-description fpvctrl-better-description-mobile">
                  What if the winding road to piloting drones was supported by{' '}
                  <a
                    href="https://store.steampowered.com/app/1278060/FPV_SkyDive__FPV_Drone_Simulator/"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    onMouseDown={event => event.preventDefault()}
                  >
                    Orqa FPV.Skydive
                  </a>{' '}
                  racing and freestyle simulator optimized for an immersive
                  flying experience? Orqa FPV.Ctrl guides your pilot journey
                  providing a safe space to sharpen your skills, enhance safety
                  and build confidence without the threat of crashes.
                </p>
              )}
            </div>
          </section>

          <section className="fpvctrl__skydive--wrapper">
            <section className="fpvctrl__splitsection--primary">
              <div className="skydive--content-wrapper">
                <img
                  src={logoOrqaSymbol}
                  alt="Brand Logo"
                  className="s-bottom--med"
                  height={50}
                  style={{ objectFit: 'contain' }}
                />
                <h2 className="fpvctrl__skydive--title">FPV SkyDive</h2>
                <p className="fpvctrl__skydive--description">
                  Freestyle simulator for improved drone racing.
                </p>
                <div className="fpvctrl__skydive--list">
                  <div className="u-display--flex fpvctrl__skydive--content s-right--lrg">
                    <img src={iconMap} alt="Map Icon" />
                    <p className="fpvctrl-skydive-list-text">
                      Practice racing skills or enjoy freestyling with selected
                      maps.
                    </p>
                  </div>
                  <div className="u-display--flex fpvctrl__skydive--content">
                    <img src={iconPc} alt="Personal Computer Icon" />
                    <p className="fpvctrl-skydive-list-text">
                      Platform agnostic. Run FPV.SkyDive on PC, Mac or Linux
                      computer.
                    </p>
                  </div>
                </div>
                <div className="fpvctrl__skydive--list">
                  <div className="u-display--flex fpvctrl__skydive--content s-right--lrg">
                    <img src={iconDrone} alt="Aerial Vehicle Icon" />
                    <p className="fpvctrl-skydive-list-text">
                      Drone physics optimised for the most realistic flying
                      experience.
                    </p>
                  </div>
                  <div className="u-display--flex fpvctrl__skydive--content">
                    <img src={iconGear} alt="Seamless Integration Icon" />
                    <p className="fpvctrl-skydive-list-text">
                      Seamless integration with FPV.Ctrl.
                    </p>
                  </div>
                </div>
              </div>
              <img
                src={skydiveDrone}
                alt="Drone from the SkyDive Game"
                className="fpvctrl__img--primary"
              />
            </section>
            <div className="fpvctrl__btn--wrapper">
              <a
                href="https://bit.ly/fpvskydive20"
                className="btn btn--primary btn--med"
                target="_blank"
                onMouseDown={event => event.preventDefault()}
                rel="nofollow noreferrer"
              >
                {this.state.extraSmallMobile
                  ? 'FPV SkyDive Steam'
                  : 'FPV SkyDive on Steam'}
              </a>
            </div>
          </section>

          <section className="fpvctrl-ghost-parent">
            <div className="fpvctrl-hero">
              <div className="fpvctrl-ghost-text">
                <div className="fpvctrl-hero-title-section">
                  <h3 className="fpvctrl-hero-subtitle">ROBUST AND RELIABLE</h3>
                  <h2 className="fpvctrl-ghost-title">GHOST UBERLITE</h2>
                </div>
                <div className="fpvctrl-ghost-description-container">
                  <p className="fpvctrl-hero-description">
                    Making progress with Orqa FPV.Ctrl is simple: once you’ve
                    built the confidence to take your skills to the real world,
                    all you need is the Ghost Uberlite radio module that
                    connects to your drone, and you’re ready to fly.
                  </p>
                </div>

                <div className="dreamX__discover--button">
                  <a
                    href="https://shop.orqafpv.com/products/ghost-uberlite-tx-module?_pos=1&_sid=2b2a24383&_ss=r"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn--primary btn--med"
                    onMouseDown={event => event.preventDefault()}
                  >
                    buy now
                  </a>
                </div>
              </div>
              <img
                src={fpvGhostController}
                alt="FPV Ctrl Product"
                className="fpvctrl-ghost-product"
              />
            </div>
          </section>

          <section id="MobileApp" className="fpvctrl__splash">
            <div className="fpvctrl-mobile-section">
              <div className="fpvctrl-mobile-text">
                <h2 className="fpvctrl__title--primary s-bottom--lrg">
                  Dedicated FPV.Ctrl mobile app to manage your settings.
                </h2>
                <p className="fpvctrl__text--primary s-bottom--xlrg">
                  Manage settings, update firmware, assign channels or calibrate
                  your sticks using FPV.Ctrl mobile application. Intuitive
                  interface and user experience.
                </p>
              </div>
              <div className="fpvctrl__slider--mobile">
                <img
                  src={fpvctrlPhone}
                  alt="Iphone Screen Representation"
                  className="fpvctrl__slider--img-absolute"
                />
                <Slider {...settingsMobile}>
                  <div>
                    <img
                      src={fpvctrlModels}
                      alt="ORQA FPV.Ctrl App Interface"
                      className="fpvctrl__slider--secondary-img"
                    />
                  </div>

                  <div>
                    <img
                      src={fpvctrlMenu}
                      alt="ORQA FPV.Ctrl App: Main Menu Navigation"
                      className="fpvctrl__slider--secondary-img"
                    />
                  </div>

                  <div className="">
                    <img
                      src={fpvctrlInfo}
                      alt="ORQA FPV.Ctrl App: Device Information and Settings"
                      className="fpvctrl__slider--secondary-img"
                    />
                  </div>
                </Slider>
              </div>
            </div>
            <div className="appstore">
              <a
                href="https://play.google.com/store/apps/details?id=com.orqafpv.fpvctrl&hl=en&gl=US"
                target="_blank"
                rel="noopener noreferrer nofollow"
                title="Orqa FPV.Ctrl application on Google Play"
                onMouseDown={event => event.preventDefault()}
              >
                <img
                  src={fpvconnectGoogleplay}
                  alt="Download on the App Store"
                />
              </a>
              <a
                href="https://apps.apple.com/hr/app/orqa-fpv-ctrl/id1562323020?l=hr"
                target="_blank"
                rel="noopener noreferrer nofollow"
                title="Orqa FPV.Ctrl application on App Store"
                onMouseDown={event => event.preventDefault()}
              >
                <img src={fpvConnectAppstore} alt="Download on Google Play" />
              </a>
            </div>
          </section>

          <section className="fpvctrl__wrapper--secondary">
            <div className="fpvctrl__content-container">
              <div className="fpvctrl__wrapper--tertiary">
                <h2 className="fpvctrl-cta-title">
                  Excited about your next drone mission?
                </h2>
                <p className="fpvctrl-cta-description">
                  Start your journey with our new FPV.Ctrl today and take your
                  skills to a whole new level.
                </p>
                <a
                  href="https://shop.orqafpv.com/products/orqa-orqa-fpv-ctrl-radio-controller"
                  className="btn btn--primary btn--med"
                  target="_blank"
                  rel="noopener noreferrer"
                  onMouseDown={event => event.preventDefault()}
                >
                  Buy now
                </a>
              </div>
            </div>
          </section>

          {/* <section className="fpvctrl__cta">
            <div className="wrapper wrapper--wide s-bottom--xlrg">
              <section>
                <h2 className="t-beta t-primary  s-bottom--xlrg">
                  Ready to master the art of flying?
                </h2>
                <p className="s-bottom--lrg">
                  Join our FPV.Ctrl newsletter to learn more about pricing and
                  availability.
                </p>
                <div className="fpvctrl__form">
                  <form
                    action="https://share.hsforms.com/1_X4KgDI3TzqxSCRmcUm_0g5d8o5?utm_medium=email&_hsmi=2&_hsenc=p2ANqtz-_tBAGvBxGbCubAei1u9NSPfBfqcv6Jxta_MLXxknhH0U0Z7yVdLBL-6X4aKo5B_2HgtIAVy8e_wYEZ7dF5dqBCnNkZgg&utm_content=2&utm_source=hs_email"
                    method="get"
                    id="embedded-subscribe-form"
                    name="embedded-subscribe-form"
                    className="validate"
                    target="_blank"
                    noValidate
                  >
                    <input
                      type="email"
                      name="email"
                      className="input input--med required email"
                      placeholder="E-mail address"
                      id="email"
                    />
                    <button
                      type="submit"
                      value="Subscribe"
                      name="subscribe"
                      id="embedded-subscribe"
                      className="btn btn--primary btn--med"
                    >
                      Subscribe
                    </button>
                    <div
                      style={{ position: 'absolute', left: '-5000px' }}
                      aria-hidden="true"
                    >
                      <input
                        type="text"
                        name="b_f528df63a6bb5a1820706dad8_4247aa8b2d"
                        tabIndex={-1}
                        value=""
                      />
                    </div>
                  </form>
                </div>
              </section>
            </div>
          </section> */}
        </section>
      </>
    );
  }
}
